/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { onboardingPatchInputDataOrganisationHeadcountSchema } from './OnboardingPatchInputDataOrganisationHeadcountSchema'
import { onboardingPatchInputDataRecruitingVolumeSchema } from './OnboardingPatchInputDataRecruitingVolumeSchema'

export const onboardingPatchInputDataSchema = z.object({
	language: z.string().nullable().optional(),
	organisationHeadcount: onboardingPatchInputDataOrganisationHeadcountSchema.nullable().optional(),
	recruitingVolume: onboardingPatchInputDataRecruitingVolumeSchema.nullable().optional(),
	contactsCandidates: z.boolean().nullable().optional(),
	managesTeam: z.boolean().nullable().optional(),
	phoneNumber: z.string().nullable().optional(),
})

export type OnboardingPatchInputDataSchema = z.infer<typeof onboardingPatchInputDataSchema>
